
import { FC } from "react";
import { useLocation, useParams, Navigate } from "react-router-dom";


const PageContentRedirect: FC = () => {
    const location = useLocation();

    const params = useParams();

    const searchParams = new URLSearchParams(location.search);

    if (params.species && searchParams.has('page')) {
        return <Navigate replace to={`/${params.species}/content/${searchParams.get('page')}`} />
    }

    if (params.species) {
        return <Navigate replace to={`/${params.species}/error/404`} />
    }

    return <Navigate replace to={`/error/404`} />
}

export default PageContentRedirect;